import { render } from "./contributionItemModal.vue?vue&type=template&id=25b54285&scoped=true"
import script from "./contributionItemModal.vue?vue&type=script&lang=js"
export * from "./contributionItemModal.vue?vue&type=script&lang=js"

import "./contributionItemModal.vue?vue&type=style&index=0&id=25b54285&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b54285"]])

export default __exports__